<template>
  <div v-if="!loading && isAuthorized" class="app">
    <tgb-navbar
      :title="this.title"
      :icon="this.icon"
      :nav-links="this.navLinks"
      :active-tab="this.activeTab"
      :navIcons="this.navIcons"
      :launcher-applications="this.launcherApplications"
      :launcher-discover-applications="this.launcherDiscoverApplications"
      :launcher-staff-tools="this.launcherStaffTools"
      :classes="this.classes"
      :user="this.user"
      :defaultAvatar="this.defaultAvatar"
      @click-navbar-brand="this.handleClickNavbarBrand"
      @click-navbar-link="() => {}"
      @click-navbar-icon="this.handleClickNavbarIcon"
      @click-launcher-application="this.handleClickLauncherApplication"
    >
      <!-- A little jank,
        so adding extra failsafes to make sure this doesn't render outside a production -->
      <nav-component
        v-if="production && production._id && this.currentRoute !== 'productions'"
      />
    </tgb-navbar>

    <router-view :key="routerKey" />

    <version-check-toast />
  </div>

  <div v-else-if="!isAuthorized" class="error-message">
    <h1>
      Something went wrong.
    </h1>

    <button
      class="btn btn-link"
      @click="reload"
    >
      Reload Page
    </button>
  </div>

  <div v-else />
</template>

<script>
import { mapState } from 'vuex';

import NavComponent from './nav/Nav.vue';
import VersionCheckToast from './VersionCheckToast.vue';
import Analytics from '../utils/analytics';

export default {
  components: {
    NavComponent,
    VersionCheckToast,
  },

  watch: {
    userId(userId) {
      if (userId && !this.identified) {
        // Identify for analytics and tracking
        this.identify();
      }
    },

    $route(to) {
      this.currentRoute = to.name;

      if (this.currentRoute === 'productions') {
        this.$store.dispatch('clearProduction');
        document.querySelector('title').innerText = 'Tagboard Producer';
      }
    },
  },

  data() {
    return {
      loading: true,
      isAuthorized: true,
      identified: false,

      currentRoute: this.$route.name,
      listener: null,
      title: 'Tagboard Producer',
      icon: './producer/assets/img/logo-producer.svg',
      classes: 'dark navbar',
      activeTab: '',
      navLinks: [],
      launcherApplications: [
        {
          name: 'Producer',
          url: process.env.TAGBOARD_PRODUCER_URL,
          icon: './producer/assets/img/logo-producer.svg',
        },
        {
          name: 'Account',
          url: process.env.TAGBOARD_ACCOUNT_URL,
          icon: './producer/assets/img/logo-builders.svg',
        },
      ],
      launcherDiscoverApplications: [
        {
          name: 'Help Center',
          url: 'https://help.tagboard.com',
          icon: './producer/assets/img/logo-help-center.svg',
        },
        {
          name: 'Product Updates',
          url: `https://${process.env.DOMAIN}/category/product/`,
          icon: './producer/assets/img/logo-product-updates.svg',
        },
      ],
      launcherStaffTools: [
        {
          name: 'Tashboard',
          url: process.env.TAGBOARD_TASHBOARD_URL,
          icon: './producer/assets/img/logo-tashboard.svg',
        },
      ],
      defaultAvatar: './producer/assets/img/profile_placeholder.png',
      domain: process.env.DOMAIN,
    };
  },

  created() {
    this.getUser();
  },

  mounted() {
    this.listener = window.addEventListener('keyup', (event) => {
      // Ignore key presses if user isn't inside a production
      if (!this.production?._id) {
        return;
      }

      let direction;
      if (event.keyCode === 39) {
        direction = 'next';
      } else if (event.keyCode === 37) {
        direction = 'previous';
      } else if (event.keyCode === 32) {
        this.$store.dispatch('togglePostVideo');
      }

      if (direction) {
        this.advance(direction);
      }
    });

    this.$store.dispatch('subscribeToIntercom');
  },

  destroyed() {
    window.removeEventListener('keyup', this.listener);
  },

  methods: {
    reload() {
      window.location.reload();
    },

    identify() {
      Analytics.setToken(this.$store.state.user.token);
      Analytics.identify(this.$store.state.user.id, this.$store.state.user);
      this.identified = true;
    },

    async getUser() {
      try {
        this.isAuthorized = await this.$store.dispatch('getUserInfo');
      } catch (err) {
        console.error('Failed to get info for logged in user:', err);
        this.isAuthorized = false;
      } finally {
        this.loading = false;
      }
    },

    advance(direction) {
      this.$store.dispatch('advance', direction);
    },

    handleClickNavbarBrand() {
      if (this.$route.name === 'productions') {
        return;
      }

      this.$router.push({ name: 'productions' });
    },

    handleClickNavbarIcon(icon) {
      switch (icon.id) {
        case 'bellIcon':
          this.$store.dispatch('toggleHighlightsModal');
          break;
        case 'helpIcon':
          this.$store.dispatch('toggleIntercom');
          break;

        default: break;
      }
    },

    handleClickLauncherApplication(application) {
      window.open(application.url, '_blank');
    },
  },

  computed: {
    ...mapState({
      userId: (state) => state.user.id,

      // Gotta add a couple attributes for the navbar component
      user: (state) => ({
        ...state.user,
        user_id: state.user.id,
        avatar: state.user.profileImageUrl,
      }),
    }),

    /**
    * Using production ID as router key forces a reload if user pastes in a new production URL,
    * or uses the back button to navigate
    */
    routerKey() {
      return this.$route.params?.production_id || null;
    },

    production() {
      return this.$store.state.production.production;
    },

    navIcons() {
      switch (this.currentRoute) {
        case 'productions':
          return [
            {
              id: 'helpIcon',
              iconClass: 'far fa-question-circle',
              containerClass: 'help-icon',
            },
          ];
        default:
          return [
            // {
            //   id: 'bellIcon',
            //   iconClass: 'fas fa-bell',
            //   containerClass: ''
            // },
            {
              id: 'helpIcon',
              iconClass: 'far fa-question-circle',
              containerClass: 'help-icon',
            },
          ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
